import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import Button from "../../../../components/common/button/Button";
import styles from "./WorkHistory.scss";
import { Form, FormGroup } from "react-bootstrap";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import { getUserData, getUserDataById } from "../../../../actions/user.actions";
import AddBox from "../../completeProfile/components/AddBox";

class WorkHistory extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { memberId } = this.props;
    if (memberId) {
      this.props.getUserDataById(memberId);
    } else {
      this.props.getUserData();
    }
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <section>
        <ScrollToTopOnMount />
        <section className={styles.workHistory}>
          <div className={styles.content}>
            <h2 className={styles.title}>Work History</h2>

            <Form onSubmit={this.props.handleSubmit}>
              <div className={styles.form}>
                <FormGroup>
                  <div className={styles.subtitle}>
                    Let companies know where you’ve worked to help them better
                    understand your career, qualifications, and professional
                    interests.
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className={styles.dividerNoPadding} />

                  <AddBox
                    name="work_history"
                    optionName="company_id"
                    inputName="role"
                    placeholder="Role"
                    placeholderTypeahead="Company"
                    options={this.props.companies}
                    addText="Add another company and role"
                    typeahead={true}
                    prefix="Add new Company: "
                    isLoading={this.props.isLoadingCompany}
                    labelKey="name"
                    valueKey="company_id"
                    selectOpts={this.props.user && this.props.user.work_history}
                    allowNew={true}
                    showYearsWorked={true}
                    noPaddingRight={true}
                    inputNameExtra="years"
                    focusOut={(query, selected, name) => {
                      if (
                        !selected ||
                        !Array.isArray(selected) ||
                        !selected.length
                      ) {
                        this.props.change(`${name}`, null);

                        if (query) {
                          this.props.change(`${name}[0].company_name`, query);
                        }
                      }
                    }}
                    onSearch={query => {
                      this.props.onSearchCompanies(query);
                    }}
                  />
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div className={styles.CTAContainer}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="Save Changes"
                    isDisabled={!valid || submitting || this.props.saving}
                    isLoading={this.props.saving}
                    loadingText="Saving..."
                  />
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

WorkHistory = reduxForm({
  form: "workHistory",
  enableReinitialize: true,
  touchOnBlur: true,
  touchOnChange: true
})(WorkHistory);

WorkHistory = connect(
  state => {
    return {
      user: state.user.data,
      initialValues: state.user.data,
      saving: state.user.loading
    };
  },
  dispatch => {
    return {
      getUserData: () => dispatch(getUserData()),
      getUserDataById: id => dispatch(getUserDataById(id))
    };
  }
)(WorkHistory);

export default WorkHistory;



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/components/WorkHistory.js